import React from 'react';
export function Modulo2Page() {
  return <div className="min-h-screen bg-[#0a0a0a] text-[#e0e0e0] font-body" data-id="element-672">
      {/* TOP NAV */}
      <nav className="sticky top-0 z-[100] flex h-[56px] items-center justify-between border-b border-[#1a1a1a] bg-black px-4 md:px-10" data-id="element-673">
        <div className="font-heading text-[13px] font-black tracking-[3px] text-white uppercase" data-id="element-674">
          AI <span className="text-[#F5C842]" data-id="element-675">WEB CLOSER</span>
        </div>
        <div className="flex gap-1 overflow-x-auto" data-id="element-676">
          <a href="/modulo-1" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-677">
            Módulo 1
          </a>
          <a href="/modulo-2" className="rounded bg-[#F5C842] px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-black transition-all" data-id="element-678">
            Módulo 2
          </a>
          <a href="/modulo-3" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-679">
            Módulo 3
          </a>
          <a href="/modulo-4" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-680">
            Módulo 4
          </a>
        </div>
      </nav>

      {/* HERO */}
      <div className="border-b-[3px] border-[#F5C842] bg-gradient-to-br from-black to-[#0d0d0d] px-6 py-10 md:px-20 md:py-[60px] md:pb-[50px]" data-id="element-681">
        <div className="mb-5 flex items-center gap-2.5" data-id="element-682">
          <div className="rounded-sm bg-[#F5C842] px-3.5 py-1 font-heading text-[9px] font-black tracking-[3px] text-black uppercase" data-id="element-683">
            Módulo 2 de 4
          </div>
          <div className="text-[11px] tracking-[2px] text-[#444] uppercase" data-id="element-684">
            ⏱ 20 minutos · Herramienta: Ai Website Arbitrage
          </div>
        </div>
        <div className="mb-4 font-heading text-4xl md:text-[48px] font-black leading-[1.05] text-white" data-id="element-685">
          El Cerebro
          <br data-id="element-686" />
          <span className="text-[#F5C842]" data-id="element-687">Cazador</span>
        </div>
        <div className="mb-8 max-w-[600px] text-[15px] leading-[1.7] text-[#888]" data-id="element-688">
          Cómo usar el cerebro de IA "Ai Website Arbitrage" para encontrar 10
          prospectos perfectos en menos de 15 minutos — sin buscar manualmente.
        </div>
        <div className="flex flex-col md:flex-row gap-4 md:gap-6" data-id="element-689">
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-690">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-691"></div>
            Herramienta: Ai Website Arbitrage en HEYLLOYD
          </div>
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-692">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-693"></div>4
            filtros del prospecto ideal
          </div>
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-694">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-695"></div>
            Lista de 5 prospectos listos para contactar
          </div>
        </div>
      </div>

      {/* MAIN */}
      <div className="mx-auto max-w-[1100px] px-4 py-10 md:px-10 md:py-[50px]" data-id="element-696">
        {/* VIDEO */}
        <div className="mb-10" data-id="element-697">
          <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-698">
            <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-699"></span>
            Video del Módulo
          </div>
          <a href="#" className="group block overflow-hidden rounded-[10px] border-2 border-[#1e1e1e] transition-all duration-250 hover:-translate-y-0.5 hover:border-[#F5C842]" data-id="element-700">
            <div className="relative flex h-[280px] flex-col items-center justify-center overflow-hidden" style={{
            backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 40px, rgba(245,200,66,0.015) 40px, rgba(245,200,66,0.015) 41px), linear-gradient(135deg, #0d0d0d 0%, #141414 50%, #0a0a0a 100%)'
          }} data-id="element-701">
              <div className="absolute inset-x-0 bottom-0 h-[80px] bg-gradient-to-t from-black/60 to-transparent" data-id="element-702"></div>
              <div className="relative z-10 mb-5 flex h-[80px] w-[80px] items-center justify-center rounded-full border-[3px] border-[#F5C842]" data-id="element-703">
                <div style={{
                width: 0,
                height: 0,
                borderTop: '14px solid transparent',
                borderBottom: '14px solid transparent',
                borderLeft: '24px solid #F5C842',
                marginLeft: '6px'
              }} data-id="element-704"></div>
              </div>
              <div className="relative z-10 px-10 text-center font-heading text-[20px] font-black text-white" data-id="element-705">
                MÓDULO 2 — El Cerebro Cazador
              </div>
              <div className="relative z-10 mt-2 text-[11px] text-[#555]" data-id="element-706">
                Haz clic para ver el video en Google Drive
              </div>
            </div>
            <div className="flex items-center justify-between bg-[#F5C842] px-6 py-3" data-id="element-707">
              <span className="font-heading text-[11px] font-black tracking-[1px] text-black uppercase" data-id="element-708">
                ▶ Ver Video Completo — Google Drive
              </span>
              <span className="font-heading text-[16px] font-black text-black" data-id="element-709">
                →
              </span>
            </div>
          </a>
        </div>

        {/* TOOL HIGHLIGHT */}
        <div className="mb-8 flex flex-col md:flex-row gap-6 items-start rounded-lg border border-[#2a2a2a] border-t-[3px] border-t-[#F5C842] bg-black px-6 py-7 md:px-8" data-id="element-710">
          <div className="text-[48px] leading-none shrink-0" data-id="element-711">🧠</div>
          <div data-id="element-712">
            <div className="mb-1.5 font-heading text-[8px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-713">
              Heylloyd — Cerebro de IA
            </div>
            <div className="mb-2 font-heading text-[24px] font-black text-white" data-id="element-714">
              Ai Website Arbitrage
            </div>
            <div className="max-w-[700px] text-[13px] leading-[1.7] text-[#888]" data-id="element-715">
              La IA personalizada que escanea el mercado local y te entrega una
              lista de negocios sin sitio web o con sitios obsoletos. Solo le
              dices el tipo de negocio y la ciudad — ella hace todo el trabajo
              de investigación en segundos.
            </div>
          </div>
        </div>

        {/* HOW TO USE STEPS */}
        <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-716">
          <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-717"></span>
          Cómo Usar Ai Website Arbitrage
        </div>
        <div className="mb-8 grid grid-cols-2 md:grid-cols-4 gap-3.5" data-id="element-718">
          <div className="rounded-lg border border-[#1e1e1e] bg-[#111] px-4 py-[18px] text-center" data-id="element-719">
            <div className="mx-auto mb-3 flex h-9 w-9 items-center justify-center rounded-full bg-[#F5C842] font-heading text-[14px] font-black text-black" data-id="element-720">
              1
            </div>
            <div className="mb-1 text-[11px] font-bold text-white" data-id="element-721">
              Abre HEYLLOYD
            </div>
            <div className="text-[11px] leading-[1.4] text-[#666]" data-id="element-722">
              Accede a tu cuenta y selecciona el cerebro "Ai Website Arbitrage"
            </div>
          </div>
          <div className="rounded-lg border border-[#1e1e1e] bg-[#111] px-4 py-[18px] text-center" data-id="element-723">
            <div className="mx-auto mb-3 flex h-9 w-9 items-center justify-center rounded-full bg-[#F5C842] font-heading text-[14px] font-black text-black" data-id="element-724">
              2
            </div>
            <div className="mb-1 text-[11px] font-bold text-white" data-id="element-725">
              Ingresa el nicho
            </div>
            <div className="text-[11px] leading-[1.4] text-[#666]" data-id="element-726">
              Escribe el tipo de negocio (ej: "peluquerías", "restaurantes",
              "talleres")
            </div>
          </div>
          <div className="rounded-lg border border-[#1e1e1e] bg-[#111] px-4 py-[18px] text-center" data-id="element-727">
            <div className="mx-auto mb-3 flex h-9 w-9 items-center justify-center rounded-full bg-[#F5C842] font-heading text-[14px] font-black text-black" data-id="element-728">
              3
            </div>
            <div className="mb-1 text-[11px] font-bold text-white" data-id="element-729">
              Ingresa la ciudad
            </div>
            <div className="text-[11px] leading-[1.4] text-[#666]" data-id="element-730">
              Escribe tu ciudad o la ciudad donde quieres conseguir clientes
            </div>
          </div>
          <div className="rounded-lg border border-[#1e1e1e] bg-[#111] px-4 py-[18px] text-center" data-id="element-731">
            <div className="mx-auto mb-3 flex h-9 w-9 items-center justify-center rounded-full bg-[#F5C842] font-heading text-[14px] font-black text-black" data-id="element-732">
              4
            </div>
            <div className="mb-1 text-[11px] font-bold text-white" data-id="element-733">
              Analiza los resultados
            </div>
            <div className="text-[11px] leading-[1.4] text-[#666]" data-id="element-734">
              La IA te entrega nombre, teléfono y estado del sitio web de cada
              negocio
            </div>
          </div>
        </div>

        {/* FILTERS */}
        <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-735">
          <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-736"></span>
          Los 4 Filtros del Prospecto Ideal
        </div>
        <div className="mb-8 grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-737">
          <div className="flex items-start gap-3 rounded-lg border border-[#1e1e1e] bg-[#111] px-[18px] py-4" data-id="element-738">
            <div className="mt-[1px] flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded bg-[#F5C842] text-[11px] font-black text-black" data-id="element-739">
              ✓
            </div>
            <div data-id="element-740">
              <div className="mb-[3px] text-[12px] font-bold text-white" data-id="element-741">
                Sin sitio web
              </div>
              <div className="text-[11px] leading-[1.4] text-[#666]" data-id="element-742">
                La señal más clara de oportunidad. Si no tienen sitio, ya saben
                que lo necesitan — solo falta que alguien se los ofrezca.
              </div>
            </div>
          </div>
          <div className="flex items-start gap-3 rounded-lg border border-[#1e1e1e] bg-[#111] px-[18px] py-4" data-id="element-743">
            <div className="mt-[1px] flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded bg-[#F5C842] text-[11px] font-black text-black" data-id="element-744">
              ✓
            </div>
            <div data-id="element-745">
              <div className="mb-[3px] text-[12px] font-bold text-white" data-id="element-746">
                Sitio con más de 3 años
              </div>
              <div className="text-[11px] leading-[1.4] text-[#666]" data-id="element-747">
                Un sitio viejo es casi tan malo como no tener. El dueño sabe que
                está desactualizado y está abierto a mejorarlo.
              </div>
            </div>
          </div>
          <div className="flex items-start gap-3 rounded-lg border border-[#1e1e1e] bg-[#111] px-[18px] py-4" data-id="element-748">
            <div className="mt-[1px] flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded bg-[#F5C842] text-[11px] font-black text-black" data-id="element-749">
              ✓
            </div>
            <div data-id="element-750">
              <div className="mb-[3px] text-[12px] font-bold text-white" data-id="element-751">
                Buenas reseñas en Google
              </div>
              <div className="text-[11px] leading-[1.4] text-[#666]" data-id="element-752">
                Significa que ya tienen clientes reales y están activos. Un
                sitio web para ellos es una inversión, no un gasto.
              </div>
            </div>
          </div>
          <div className="flex items-start gap-3 rounded-lg border border-[#1e1e1e] bg-[#111] px-[18px] py-4" data-id="element-753">
            <div className="mt-[1px] flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded bg-[#F5C842] text-[11px] font-black text-black" data-id="element-754">
              ✓
            </div>
            <div data-id="element-755">
              <div className="mb-[3px] text-[12px] font-bold text-white" data-id="element-756">
                Negocio físico con dirección
              </div>
              <div className="text-[11px] leading-[1.4] text-[#666]" data-id="element-757">
                Negocios físicos tienen más urgencia de aparecer en búsquedas
                locales de Google que negocios 100% online.
              </div>
            </div>
          </div>
        </div>

        {/* WHAT TO SAVE — TWO COLUMN CARDS */}
        <div className="mb-8 grid grid-cols-1 gap-5 md:grid-cols-2" data-id="element-758">
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-759">
            <div className="flex items-center gap-2 border-b border-[#1e1e1e] bg-[#161616] px-[18px] py-3" data-id="element-760">
              <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-761"></div>
              <div className="font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-762">
                Datos que debes guardar de cada prospecto
              </div>
            </div>
            <div className="px-[18px] py-[18px] text-[13px] leading-[1.75] text-[#bbb]" data-id="element-763">
              <ul className="flex flex-col" data-id="element-764">
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1.5" data-id="element-765">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-766">
                    →
                  </span>
                  <strong className="text-white" data-id="element-767">Nombre del negocio</strong>
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1.5" data-id="element-768">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-769">
                    →
                  </span>
                  <strong className="text-white" data-id="element-770">Nombre del dueño</strong>
                  <span className="text-[#bbb]" data-id="element-771">(si aparece en Google)</span>
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1.5" data-id="element-772">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-773">
                    →
                  </span>
                  <strong className="text-white" data-id="element-774">Teléfono / WhatsApp</strong>
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1.5" data-id="element-775">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-776">
                    →
                  </span>
                  <strong className="text-white" data-id="element-777">Estado del sitio</strong>
                  <span className="text-[#bbb]" data-id="element-778">— sin sitio o sitio viejo</span>
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1.5" data-id="element-779">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-780">
                    →
                  </span>
                  <strong className="text-white" data-id="element-781">Número de reseñas</strong>
                  <span className="text-[#bbb]" data-id="element-782">en Google</span>
                </li>
                <li className="flex items-start gap-2 py-1.5" data-id="element-783">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-784">
                    →
                  </span>
                  <strong className="text-white" data-id="element-785">Por qué lo elegiste</strong>
                  <span className="text-[#bbb]" data-id="element-786">— tu razón de contacto</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-787">
            <div className="flex items-center gap-2 border-b border-[#1e1e1e] bg-[#161616] px-[18px] py-3" data-id="element-788">
              <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-789"></div>
              <div className="font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-790">
                Por qué las buenas reseñas son clave
              </div>
            </div>
            <div className="px-[18px] py-[18px] text-[13px] leading-[1.75] text-[#bbb]" data-id="element-791">
              Un negocio con buenas reseñas ya tiene clientes. Ya están ganando
              dinero. Un sitio web para ellos{' '}
              <strong className="text-white" data-id="element-792">
                no es un gasto, es una inversión
              </strong>{' '}
              que les va a traer más clientes.
              <br data-id="element-793" />
              <br data-id="element-794" />
              Eso hace que la conversación de venta sea completamente diferente.
              No estás convenciéndolos de gastar — estás mostrándoles cómo{' '}
              <strong className="text-white" data-id="element-795">ganar más</strong>.
            </div>
          </div>
        </div>

        {/* SCRIPT */}
        <div className="mb-8" data-id="element-796">
          <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-797">
            <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-798"></span>
            Guion Completo del Módulo
          </div>

          <div className="mb-4" data-id="element-799">
            <div className="mb-1.5 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-800">
              <span className="inline-block h-[2px] w-3 bg-[#F5C842]" data-id="element-801"></span>⏱
              0:00 – 0:30 · Introducción
            </div>
            <div className="whitespace-pre-wrap rounded-r-lg border border-[#1e1e1e] border-l-[3px] border-l-[#F5C842] bg-[#0d0d0d] px-[22px] py-[18px] text-[13px] italic leading-[1.8] text-[#ccc]" data-id="element-802">
              "Bienvenido al Módulo 2. Aquí es donde la magia empieza. Voy a
              mostrarte cómo usar el cerebro de IA{' '}
              <span className="not-italic font-bold text-[#F5C842]" data-id="element-803">
                'Ai Website Arbitrage'
              </span>{' '}
              para encontrar 10 prospectos perfectos en menos de 15 minutos.
              Abre el software y sígueme."
            </div>
          </div>

          <div className="mb-4" data-id="element-804">
            <div className="mb-1.5 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-805">
              <span className="inline-block h-[2px] w-3 bg-[#F5C842]" data-id="element-806"></span>⏱
              0:30 – 15:00 · Demo en Pantalla
            </div>
            <div className="whitespace-pre-wrap rounded-r-lg border border-[#1e1e1e] border-l-[3px] border-l-[#F5C842] bg-[#0d0d0d] px-[22px] py-[18px] text-[13px] italic leading-[1.8] text-[#ccc]" data-id="element-807">
              "Primero, abre el cerebro{' '}
              <span className="not-italic font-bold text-[#F5C842]" data-id="element-808">
                'Ai Website Arbitrage'
              </span>{' '}
              en HEYLLOYD. Vas a ver una pantalla que te pide dos cosas: el tipo
              de negocio y la ciudad. Escribe, por ejemplo,{' '}
              <span className="italic text-[#666]" data-id="element-809">'peluquerías'</span> y{' '}
              <span className="italic text-[#666]" data-id="element-810">'Miami'</span>. Ahora observa
              lo que hace."
              <br data-id="element-811" />
              <br data-id="element-812" />
              "El cerebro analiza los resultados de Google Maps y te da una
              lista de negocios con su nombre, dirección, teléfono y, lo más
              importante, si tienen sitio web o no. También te dice si el sitio
              que tienen es moderno o está desactualizado."
              <br data-id="element-813" />
              <br data-id="element-814" />
              "De esta lista, quiero que identifiques los 5 mejores prospectos.
              Los mejores son los que: no tienen sitio web, tienen un sitio con
              más de 3 años de antigüedad, tienen buenas reseñas en Google (lo
              que significa que tienen clientes reales y están activos), y son
              negocios físicos con una dirección real."
              <br data-id="element-815" />
              <br data-id="element-816" />
              "¿Por qué estos criterios? Porque un negocio con buenas reseñas ya
              tiene clientes. Ya están ganando dinero. Un sitio web para ellos
              no es un gasto, es una inversión que les va a traer más clientes.
              Eso hace que la venta sea mucho más fácil."
            </div>
          </div>

          <div className="mb-4" data-id="element-817">
            <div className="mb-1.5 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-818">
              <span className="inline-block h-[2px] w-3 bg-[#F5C842]" data-id="element-819"></span>⏱
              15:00 – 20:00 · Cierre y Tarea
            </div>
            <div className="whitespace-pre-wrap rounded-r-lg border border-[#1e1e1e] border-l-[3px] border-l-[#F5C842] bg-[#0d0d0d] px-[22px] py-[18px] text-[13px] italic leading-[1.8] text-[#ccc]" data-id="element-820">
              "Tu tarea: usa el cerebro{' '}
              <span className="not-italic font-bold text-[#F5C842]" data-id="element-821">
                'Ai Website Arbitrage'
              </span>{' '}
              y encuentra tus 5 mejores prospectos. Guarda su nombre, teléfono y
              por qué los elegiste. En el Módulo 3, vamos a construir una demo
              de su sitio web antes de hablar con ellos. Eso es lo que hace que
              esta venta sea diferente a cualquier otra."
            </div>
          </div>
        </div>

        {/* TASK */}
        <div className="mb-8 rounded-r-lg border border-[#1a3a1a] border-l-[4px] border-l-[#4caf50] bg-[#0a150a] px-[26px] py-[22px]" data-id="element-822">
          <div className="mb-2.5 font-heading text-[9px] font-bold tracking-[2px] text-[#4caf50] uppercase" data-id="element-823">
            ✅ Tu Tarea — Módulo 2
          </div>
          <div className="text-[13px] leading-[1.75] text-[#bbb]" data-id="element-824">
            Usa <strong className="text-white" data-id="element-825">Ai Website Arbitrage</strong> en
            HEYLLOYD y encuentra tus{' '}
            <strong className="text-white" data-id="element-826">5 mejores prospectos</strong>. No
            pases al Módulo 3 sin completar esta tarea.
            <div className="mt-3 flex flex-col gap-2" data-id="element-827">
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-828">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-829">
                  1
                </div>
                Abre HEYLLOYD y selecciona el cerebro "Ai Website Arbitrage"
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-830">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-831">
                  2
                </div>
                Ingresa el tipo de negocio y tu ciudad
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-832">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-833">
                  3
                </div>
                Aplica los 4 filtros del prospecto ideal para seleccionar los
                mejores
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-834">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-835">
                  4
                </div>
                Guarda nombre, teléfono y razón de selección de cada uno
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-836">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-837">
                  5
                </div>
                <strong className="text-white" data-id="element-838">
                  Selecciona tus 5 mejores prospectos y pasa al Módulo 3
                </strong>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* FOOTER NAV */}
      <div className="mt-5 flex items-center justify-between border-t border-[#1a1a1a] bg-black px-4 py-6 md:px-10" data-id="element-839">
        <a href="/modulo-1" className="flex items-center gap-1.5 text-[12px] font-bold text-[#555] transition-colors hover:text-white" data-id="element-840">
          ← Módulo 1
        </a>
        <div className="font-heading text-[11px] font-black tracking-[3px] text-[#333] uppercase" data-id="element-841">
          AI <span className="text-[#F5C842]" data-id="element-842">WEB CLOSER</span>
        </div>
        <a href="/modulo-3" className="flex items-center gap-2 rounded bg-[#F5C842] px-7 py-3 font-heading text-[12px] font-black tracking-[1px] text-black uppercase transition-opacity hover:opacity-85" data-id="element-843">
          Módulo 3: La Demo que Cierra Sola →
        </a>
      </div>
    </div>;
}